export default __webpack_public_path__ + "static/media/img-support-banner-new-mobile.6da7f128.png";